import { Button } from "primereact/button";
import Text from "./Text";

interface IButtonGroupProps {
    invalid?: boolean;
    group: { 
        name: string; 
        disabled: boolean;
        selected: boolean;
        onClick: () => void;
    }[];
}

export default function ButtonGroup({ group, invalid }: IButtonGroupProps) {
    return (
        group.map(g => {
            return (
                <Button 
                    disabled={g.disabled}
                    key={g.name} 
                    onClick={() => {
                        g.onClick();
                    }} 
                    className={`rounded bg-bluegray-200 px-3 py-2 ${
                        g.disabled && g.selected
                            ? 'bg-bluegray-600' 
                            : g.selected
                                ? 'bg-bluegray-900' 
                                : ''}
                        ${invalid ? "border border-red-500" : "border border-800"}`}
                >
                    <Text className={`${g.selected ? 'text-white' : ''}`}>{g.name}</Text>
                </Button>
            )
        })
    )
}
